import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.3615 4.51601C13.8284 4.60688 14.1333 5.05937 14.0425 5.52669L11.4635 18.8024C11.3728 19.2697 10.9207 19.5749 10.4538 19.484C9.98693 19.3931 9.68205 18.9406 9.77283 18.4733L12.3518 5.19763C12.4426 4.73031 12.8946 4.42514 13.3615 4.51601Z'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.22342 17.6748C8.60762 17.2676 8.5893 16.6258 8.1825 16.2412L3.98872 12.2767L8.1825 8.31216C8.5893 7.9276 8.60762 7.28576 8.22342 6.87857C7.83922 6.47139 7.19798 6.45305 6.79118 6.83761L1.8175 11.5394C1.61485 11.731 1.5 11.9977 1.5 12.2767C1.5 12.5557 1.61485 12.8224 1.8175 13.014L6.79118 17.7158C7.19798 18.1003 7.83922 18.082 8.22342 17.6748Z'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.7763 17.6748C15.3921 17.2676 15.4105 16.6258 15.8173 16.2412L20.011 12.2767L15.8173 8.31216C15.4105 7.9276 15.3921 7.28576 15.7763 6.87857C16.1605 6.47139 16.8018 6.45305 17.2086 6.83761L22.1823 11.5394C22.3849 11.731 22.4998 11.9977 22.4998 12.2767C22.4998 12.5557 22.3849 12.8224 22.1823 13.014L17.2086 17.7158C16.8018 18.1003 16.1605 18.082 15.7763 17.6748Z'
            />
        </SvgIcon>
    );
});
